module.exports = __webpack_public_path__ + "static/media/bone-break.5d5596be.svg";